import { Tabs, TabsProps } from "@mui/material";
import styles from "./styles.module.css";

interface Props extends TabsProps {
  className?: string;
}

export const AppTabs = ({ className, ...rest }: Props) => {
  return <Tabs className={className} {...rest} />;
};
